import { atom } from "jotai";

export interface AppNotificationData {
  Command?: object;
  Time?: string;
  Title?: string;
  Content?: string;
  Options: number;
  channelId?: string;
  messageId?: string;
}

export interface AppNotification {
  id: string | number;
  source: "system" | "chat";
  read: boolean;
  data: AppNotificationData;
}

interface RemoveChatNotificationsPayload {
  channelId: string;
  messageIds: Array<string | number>;
}

export const appNotificationsAtom = atom<AppNotification[]>([]);

export const appUnreadNotificationCountAtom = atom((get) =>
  get(appNotificationsAtom).reduce((count, notification) => count + (notification.read ? 0 : 1), 0),
);

export const upsertAppNotificationAtom = atom(null, (get, set, notification: AppNotification) => {
  const notifications = get(appNotificationsAtom);
  const notificationIndex = notifications.findIndex(
    (currentNotification) =>
      currentNotification.source === notification.source && String(currentNotification.id) === String(notification.id),
  );

  if (notificationIndex === -1) {
    set(appNotificationsAtom, [notification, ...notifications]);
    return;
  }

  const nextNotifications = [...notifications];
  nextNotifications[notificationIndex] = notification;
  set(appNotificationsAtom, nextNotifications);
});

export const removeAppNotificationAtom = atom(null, (get, set, id: string | number) => {
  set(
    appNotificationsAtom,
    get(appNotificationsAtom).filter((notification) => String(notification.id) !== String(id)),
  );
});

export const removeChatNotificationsAtom = atom(
  null,
  (get, set, { channelId, messageIds }: RemoveChatNotificationsPayload) => {
    const messageIdSet = new Set(messageIds.map(String));

    set(
      appNotificationsAtom,
      get(appNotificationsAtom).filter(
        (notification) =>
          notification.source !== "chat" ||
          notification.data.channelId !== channelId ||
          !notification.data.messageId ||
          !messageIdSet.has(notification.data.messageId),
      ),
    );
  },
);

export const clearAppNotificationsAtom = atom(null, (_get, set) => {
  set(appNotificationsAtom, []);
});
